module.exports = __webpack_public_path__ + "img/js_pre@2x.2d849fc5.png";